import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaDownload, FaList } from 'react-icons/fa';
import { Card, Button, TwIconButton } from 'components/common';

const BookingHeaderPrint = ({ download }) => {
  const navigate = useNavigate();
  const bookingUrl = '/booking/travel';

  return (
    <Card padding="none" className="tw-mb-3">
      <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
        <TwIconButton variant="secondary" icon={FaArrowLeft} onClick={() => navigate(-1)} title="Back" />
        <div className="tw-flex tw-items-center tw-gap-2">
          <Button size="sm" variant="secondary" leftIcon={FaDownload} onClick={download}>Download</Button>
          <Button size="sm" variant="secondary" leftIcon={FaList} onClick={() => navigate(`${bookingUrl}/list`)}>List</Button>
        </div>
      </div>
    </Card>
  );
};

BookingHeaderPrint.propTypes = {
  download: PropTypes.func.isRequired,
};

export default BookingHeaderPrint;
